// A compact icon-only action button. The label is NOT shown — it becomes the hover
// tooltip (`title`) and the accessible name (`aria-label`), so a row of these reads
// as a tidy toolbar while staying reachable by screen readers.
//
// `danger` marks a destructive action (deleting the whole publication), which is
// styled red so it never reads as just another file action sitting beside view and
// download.
export default function IconButton({ icon, label, onClick, danger }) {
  return (
    <button
      type="button"
      className={`icon-btn${danger ? ' danger' : ''}`}
      title={label}
      aria-label={label}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}
